import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Tabs,
  Tab,
} from "react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/scheduling.css";
import { fetchSpecies } from "../../api/species";
import {
  bovineObj,
  matchSpecies,
  offalObject,
  ovineObj,
  porcineObj,
  skinObject,
} from "../../constants";
import {
  createBeefBody,
  fetchBeefLastBodyAndLot,
  fetchBeefsByDate,
  fetchLambLastBodyAndLot,
  fetchLambsByDate,
  fetchPigsByDate,
  fetchPigLastBodyAndLot,
  createLambBody,
  createPigBody,
} from "../../api/scheduling";
import ErrorAlertBox from "../general/ErrorAlertBox";
import { useDispatch } from "react-redux";
import { useCompany } from "../../helpers/CompanyContext";
import {
  createBeefBodyFailure,
  createBeefBodyRequest,
  createBeefBodySuccess,
  fetchBeefBodiesFailure,
  fetchBeefBodiesRequest,
  fetchBeefBodiesSuccess,
} from "../../actions/beef_bodies";
import CustomAlert from "../general/customAlert";
import { CircularProgress } from "@mui/material";
import {
  createLambBodyRequest,
  createLambBodySuccess,
  fetchLambBodiesFailure,
  fetchLambBodiesRequest,
  fetchLambBodiesSuccess,
} from "../../actions/lamb_bodies";
import {
  createPigBodyRequest,
  createPigBodySuccess,
  fetchPigBodiesFailure,
  fetchPigBodiesRequest,
  fetchPigBodiesSuccess,
} from "../../actions/pig_bodies";
import Bodies from "./Bodies";
import Offal from "./Offal";
import {
  createOffal,
  fetchOffalsByDate,
  fetchOffalTypes,
} from "../../api/offal";
import Skin from "./Skin";
import { createSkin, fetchSkinsByDate } from "../../api/skin";

// Species only available in BVM schema
const BVM_ONLY_SPECIES = ["Caprine", "Other"];
const BVM_COMPANY_ID = 2;

const Scheduling = () => {
  const { selectedCompany } = useCompany();
  const [tabKey, setTabKey] = useState("bodies"); // Default to "Bodies" tab
  const [species, setSpecies] = useState([]);
  const [body, setBody] = useState({ ...bovineObj });
  const [lotNo, setLotNo] = useState();
  const [errorMsg, setErrorMessage] = useState("");
  const [successMessage, setSucessMessage] = useState("");
  const [showSuccessMessage, setShowSucessMessage] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [existingOffalTypes, setExistingOffalTypes] = useState([]);
  const [skinNo, setSkinNo] = useState(1);
  const [selectedSpecies, setSelectedSpecies] = useState("Bovine");
  const [matchItem, setMatchItem] = useState(null);

  useEffect(() => {
    if (matchItem)
      console.log(
        "tab specie",
        matchItem[tabKey][selectedSpecies],
        tabKey,
        selectedSpecies
      );
    setBody(
      matchItem ? { ...matchItem[tabKey][selectedSpecies] } : { ...bovineObj }
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabKey, selectedSpecies]);
  const matchMethods = {
    Bovine: {
      fetch: fetchBeefsByDate,
      create: createBeefBody,
      dispatchMethods: {
        fetch: [
          fetchBeefBodiesRequest,
          fetchBeefBodiesSuccess,
          fetchBeefBodiesFailure,
        ],
        create: [
          createBeefBodyRequest,
          createBeefBodySuccess,
          createBeefBodyFailure,
        ],
      },
    },
    Ovine: {
      fetch: fetchLambsByDate,
      create: createLambBody,
      dispatchMethods: {
        fetch: [
          fetchLambBodiesRequest,
          fetchLambBodiesSuccess,
          fetchLambBodiesFailure,
        ],
        create: [
          createLambBodyRequest,
          createLambBodySuccess,
          createBeefBodyFailure,
        ],
      },
    },
    Porcine: {
      fetch: fetchPigsByDate,
      create: createPigBody,
      dispatchMethods: {
        fetch: [
          fetchPigBodiesRequest,
          fetchPigBodiesSuccess,
          fetchPigBodiesFailure,
        ],
        create: [
          createPigBodyRequest,
          createPigBodySuccess,
          createBeefBodyFailure,
        ],
      },
    },
  };
  const dispatch = useDispatch();
  const closeErrorMsg = () => {
    setErrorMessage("");
  };
  function getInitials(str) {
    // Split the string into words
    const words = str.trim().split(/\s+/);
    let initials = "";
    // Map over the first three words and extract the first letter of each

    if (words.length > 0)
      initials = words
        .slice(0, 3)
        .map((word) =>
          word[0] && isNaN(word[0]) ? word[0].toUpperCase() : ""
        );

    // Join the initials together
    return initials.join("");
  }
  function extractNumbers(str) {
    // Use regex to match all digits in the string

    const numbers = isNaN(str) ? str.match(/\d+/g) : str;

    // Join the matched numbers into a single string and convert to an integer
    return numbers ? parseInt(numbers.join(""), 10) : 0;
  }

  useEffect(() => {
    fetchTypes();
    setMatchItem({
      bodies: {
        Bovine: null,
        Ovine: null,
        Porcine: null,
      },
      offal: {
        Bovine: offalObject,
        Ovine: offalObject,
        Porcine: offalObject,
      },
      skin: { Bovine: skinObject, Ovine: skinObject, Porcine: skinObject },
    });
    fetchSpecies()
      .then((data) => {
        setSpecies([...data]);
        setSelectedSpecies(data[0].scientific_name);
      })
      .catch((error) => {
        console.error("Error fetching species : ", error);
      });
    fetchBeefLastBodyAndLot()
      .then((res) => {
        console.log(res);
        let lot_no = extractNumbers(res.lot_no) + 1;
        const newBovine = {
          ...bovineObj,
          body_number: res.body_number + 1,
          lot_no: lot_no,
        };
        setBody({ ...newBovine });

        setMatchItem((prevState) => ({
          ...prevState,
          bodies: {
            ...prevState.bodies,
            Bovine: { ...newBovine }, // Update the Bovine value 
          },
          offal: {
            ...prevState.offal,
            // Update the Bovine value 
          },
          skin: {
            ...prevState.skin,
            // Update the Bovine value 
          },
        }));
        setLotNo(lot_no);
      })
      .catch((err) => console.log("body and lot err", err));
    fetchLambLastBodyAndLot()
      .then((res) => {
        console.log(res);
        let lot_no = extractNumbers(res.lot_no) + 1;
        const newOvine = {
          ...ovineObj,
          body_number: res.body_number + 1,
          lot_no,
        };

        setMatchItem((prevState) => ({
          ...prevState,
          bodies: {
            ...prevState.bodies,
            Ovine: { ...newOvine }, // Update the Bovine value here
          },
          offal: {
            ...prevState.offal,
            // Update the Bovine value here
          },
          skin: {
            ...prevState.skin,
            // Update the Bovine value 
          },
        }));
        setLotNo(lot_no);
      })
      .catch((err) => console.log("lamb body and lot err", err));
    fetchPigLastBodyAndLot()
      .then((res) => {
        console.log(res);
        let lot_no = extractNumbers(res.lot_no) + 1;
        const newPorcine = {
          ...porcineObj,
          body_number: res.body_number + 1,
          lot_no,
        };

        setMatchItem((prevState) => ({
          ...prevState,
          bodies: {
            ...prevState.bodies,
            Porcine: { ...newPorcine }, // Update the Bovine value
          },
          offal: {
            ...prevState.offal,
            // Update the Bovine value
          },
          skin: {
            ...prevState.skin,
            // Update the Bovine value 
          },
        }));
        setLotNo(lot_no);
      })
      .catch((err) => console.log("Pig body and lot err", err));
  }, []);
  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newVal = type === "checkbox" ? (checked ? 1 : 0) : value;

    setBody((prevState) => ({
      ...prevState,
      [name]: newVal,
    }));
  };
  const handleSpeciesChange = (e) => {
    console.log("match", e.target.value);
    setSelectedSpecies(e.target.value);

    fetchTypes(e.target.value);
    setItems([]);
  };
  const handleOriginChange = (e) => {
    let originValue = e.target.value;
    let lot_no_value = lotNo + getInitials(originValue);
    setBody({ ...body, origin: originValue, lot_no: lot_no_value });
  };
  const fetchTypes = (species = "Bovine") => {
    fetchOffalTypes(matchSpecies[species])
      .then((res) => {
        console.log("types offal", res);
        setExistingOffalTypes(res);
      })
      .catch((err) => console.log("Error in fetching offals"));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!body.production_date) setErrorMessage("Production Date is required");
    else if (!body.owner) setErrorMessage("Owner is required");
    else if (!body.origin) setErrorMessage("Origin is required");
    else {
      setErrorMessage("");
      dispatch(matchMethods[selectedSpecies]["dispatchMethods"]["create"][0]());
      matchMethods[selectedSpecies]["create"]({
        ...body,
        TS: body.TS !== "" ? body.TS : null,
      })
        .then((res) => {
          console.log(res);
          dispatch(
            matchMethods[selectedSpecies]["dispatchMethods"]["create"][1](
              res.createdBodies
            )
          );
          let newEmptyBodyObj = {
            ...matchItem[tabKey][selectedSpecies],
            body_number: parseInt(body.body_number) + parseInt(body.lot_size),
            lot_no: lotNo + 1,
            production_date: body.production_date,
          };
          console.log(
            "new empty object",
            newEmptyBodyObj,
            matchItem[tabKey][selectedSpecies],
            "tabkey",
            tabKey,
            selectedSpecies,
            matchItem
          );
          setBody({ ...newEmptyBodyObj });
          setMatchItem((prevState) => ({
            ...prevState,
            bodies: {
              ...prevState.bodies,
              [selectedSpecies]: { ...newEmptyBodyObj, production_date: null }, // Update the Bovine value here
            },
            offal: {
              ...prevState.offal,
              // Update the Bovine value 
            },
            skin: {
              ...prevState.skin,
              // Update the Bovine value 
            },
          }));

          setItems([
            ...items,
            ...res.createdBodies.sort((a, b) => a.body_number - b.body_number),

          ]);
          setSucessMessage(res.message);
          setShowSucessMessage(true);
        })
        .catch((err) => {
          console.log("error creating body", err);
          dispatch(
            matchMethods[selectedSpecies]["dispatchMethods"]["create"][2](
              "Error in creating items"
            )
          );
        });
    }
  };
  const handleOffalSubmit = (e) => {
    e.preventDefault();
    if (!body.production_date) setErrorMessage("Production Date is required");
    else if (!body.customer) setErrorMessage("Owner is required");
    //else if (!body.weight) setErrorMessage("Weight is required");
    else {
      setErrorMessage("");
      console.log("submitted OFFAL", body);
      let weight = body.weight.trim() !== "" ? body.weight : null;
      createOffal(matchSpecies[selectedSpecies], { ...body, weight })
        .then((res) => {
          console.log(res);

          let newEmptyBodyObj = {
            ...offalObject,
            production_date: body.production_date,
          };
          setBody(newEmptyBodyObj);
          setItems([...res.createdOffal, ...items]);
          setSucessMessage(res.message);
          setShowSucessMessage(true);
        })
        .catch((err) => {
          console.log("error creating offal", err);
        });
    }
  };
  const handleSkinSubmit = (e) => {
    e.preventDefault();
    if (!body.production_date) setErrorMessage("Production Date is required");
    else if (!body.customer) setErrorMessage("Owner is required");
    // else if (!body.weight) setErrorMessage("Weight is required");
    else {
      console.log("submitted Skin", body);
      setErrorMessage("");
      let weight = body.weight.trim() !== "" ? body.weight : null;
      createSkin(matchSpecies[selectedSpecies], { ...body, skinNo, weight })
        .then((res) => {
          console.log(res);

          let newEmptyBodyObj = {
            ...skinObject,
            production_date: body.production_date,
          };
          setBody(newEmptyBodyObj);
          setItems([...res.createdSkins, ...items]);
          setSucessMessage(res.message);
          setShowSucessMessage(true);
        })
        .catch((err) => {
          console.log("error creating skins", err);
        });
    }
  };
  const handleDateChange = (date) => {
    console.log("date", date, tabKey);
    setLoading(true);
    if (tabKey === "bodies") {
      dispatch(matchMethods[selectedSpecies]["dispatchMethods"]["fetch"][0]());

      matchMethods[selectedSpecies]["fetch"](date)
        .then((res) => {
          const sorted_items = res.sort(
            (a, b) => a.body_number - b.body_number
          );
          dispatch(
            matchMethods[selectedSpecies]["dispatchMethods"]["fetch"][1](
              sorted_items
            )
          );
          setItems(sorted_items);
          console.log(selectedSpecies, sorted_items);
        })
        .catch((err) => {
          dispatch(
            matchMethods[selectedSpecies]["dispatchMethods"]["fetch"][2](
              "Error in fetching items"
            )
          );
          console.log("Error fetching bodies", err);
        })
        .finally(() => setLoading(false));
    } else if (tabKey === "offal") {
      fetchOffalsByDate(matchSpecies[selectedSpecies], date)
        .then((res) => {
          setItems(res);
          console.log(selectedSpecies, res);
        })
        .catch((err) => {
          console.log("Error fetching offals", err);
        })
        .finally(() => setLoading(false));
    } else {
      fetchSkinsByDate(matchSpecies[selectedSpecies], date)
        .then((res) => {
          setItems(res);
          console.log(selectedSpecies, res);
        })
        .catch((err) => {
          console.log("Error fetching skins", err);
        })
        .finally(() => setLoading(false));
    }
    setBody({ ...body, production_date: date });
  };
  if (!body) {
    return (
      <div className="d-flex justify-content-center align-items-center mt-5">
        <CircularProgress variant="determinate" value={50} valueBuffer={20} />
      </div>
    );
  }

  return (
    <div
      className="scheduling-page d-flex flex-column pt-2"
      style={{ fontSize: "14px" }}>
      <h4 className="mb-3 text-center text-acumen-color mt-1 pt-0">
        Scheduling
      </h4>
      <Row className="mb-3">
        <Col xs={12} md={6}>
          <Form.Group className="top-row">
            <Form.Label>Species</Form.Label>
            <Form.Select
              onChange={handleSpeciesChange}
              value={selectedSpecies}
              id="species"
              name="species"
              className="w-100">
              {species.length > 0 &&
                species
                  .filter((s) => s.scientific_name && s.scientific_name.trim() !== "")
                  .filter((s) =>
                    BVM_ONLY_SPECIES.includes(s.scientific_name)
                      ? selectedCompany === BVM_COMPANY_ID
                      : true
                  )
                  .map((s, index) => (
                    <option key={s.id}>{s.scientific_name}</option>
                  ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group className="top-row">
            <Form.Label>Production Date</Form.Label>
            <br />
            <DatePicker
              selected={body.production_date}
              onChange={handleDateChange}
              dateFormat="MM/dd/yyyy"
              className="form-control w-100"
              id="production_date"
              name="production_date"
              maxDate={new Date()}
            />
          </Form.Group>
        </Col>
      </Row>

      <Tabs
        id="controlled-tab-example"
        activeKey={tabKey}
        onSelect={(k) => setTabKey(k)}
        className="mt-3 custom-tabs p-0"
        style={{ width: "auto" }}>
        <Tab eventKey="bodies" title="Bodies" className="tab-content">
          <Bodies
            body={body}
            selectedSpecies={selectedSpecies}
            items={items}
            loading={loading}
            handleChange={handleChange}
            handleOriginChange={handleOriginChange}
            handleSubmit={handleSubmit}
          />
        </Tab>
        <Tab eventKey="offal" title="Offal" className="tab-content">
          <Offal
            body={body}
            selectedSpecies={selectedSpecies}
            items={items}
            loading={loading}
            handleChange={handleChange}
            setBody={setBody}
            handleSubmit={handleOffalSubmit}
            existingTypes={existingOffalTypes}
            setExistingTypes={setExistingOffalTypes}
          />
        </Tab>
        <Tab eventKey="skin" title="Skin" className="tab-content">
          <Skin
            body={body}
            selectedSpecies={selectedSpecies}
            items={items}
            loading={loading}
            handleChange={handleChange}
            setBody={setBody}
            handleSubmit={handleSkinSubmit}
            skinNo={skinNo}
            setSkinNo={setSkinNo}
          />
        </Tab>
      </Tabs>

      {errorMsg !== "" && (
        <ErrorAlertBox message={errorMsg} onClose={closeErrorMsg} />
      )}
      {showSuccessMessage && (
        <CustomAlert
          message={successMessage}
          showMessage={showSuccessMessage}
          setShowMessage={setShowSucessMessage}
          isError={false}
        />
      )}
    </div>
  );
};

export default Scheduling;